export function parseJSON(content: string) {
  if (!content.startsWith("{") && !content.startsWith("[")) {
    return null
  }

  try {
    return JSON.parse(content) as unknown
  } catch (e) {
    return null
  }
}
